import { render, staticRenderFns } from "./ChallengeContainer.vue?vue&type=template&id=6dfa13eb&scoped=true"
import script from "./ChallengeContainer.vue?vue&type=script&lang=js"
export * from "./ChallengeContainer.vue?vue&type=script&lang=js"
import style0 from "./ChallengeContainer.vue?vue&type=style&index=0&id=6dfa13eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa13eb",
  null
  
)

export default component.exports